/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Highlight_Next_EventInputs */



/**
* | output |
* | --- |
* | "Add next Event to Selected Events" |
*
* @param {Shortcut_Keys_Desc_Highlight_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_highlight_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Highlight_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Highlight_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter l'evenement suivant aux evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge das nächste Ereignis zu den ausgewählten Ereignissen hinzu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi il prossimo evento agli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить следующее событие в список выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar el próximo evento a los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将下一个事件添加到已选事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントに次のイベントを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट्स में अगला इवेंट जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar o próximo evento aos eventos selecionados")
	return /** @type {LocalizedString} */ ("Add next Event to Selected Events")
});